import type { AuthTokens } from '@/types/api';

const ACCESS_TOKEN_KEY = 'sipaud.accessToken';
const REFRESH_TOKEN_KEY = 'sipaud.refreshToken';

/**
 * Penyimpanan token.
 *
 * Catatan keamanan: localStorage rentan terhadap XSS. Ia dipilih di sini
 * karena dashboard berada di subdomain berbeda dari API, sehingga cookie
 * HttpOnly butuh konfigurasi lintas-situs yang lebih rumit. Mitigasinya:
 * access token berumur pendek (15 menit), refresh token dirotasi dan
 * dicabut saat terdeteksi dipakai ulang, serta CSP ketat di produksi.
 *
 * TODO(keamanan): pindahkan refresh token ke cookie HttpOnly + SameSite
 * sebelum rilis produksi.
 */
export const tokenStorage = {
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  setTokens(tokens: Pick<AuthTokens, 'accessToken' | 'refreshToken'>): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  },

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  hasSession(): boolean {
    return Boolean(this.getAccessToken() && this.getRefreshToken());
  },
};
